import ProductCarousel from "../helpers/product-list/product-carousel.jsx";
import { h, render } from "preact";

class SectionProductCarousel extends HTMLElement {
  constructor() {
    super();
    this.data = scrapeSectionData(this);
    this.carousel = this.querySelector("[data-product-carousel]");
    this.carouselNext = this.querySelector("[data-product-carousel-next]");
    this.carouselPrev = this.querySelector("[data-product-carousel-prev]");
    this.init();
  }

  init() {
    const { products, collection, cardStyle } = this.data;
    const swiperParams = {
      scrollbar: {
        draggable: true,
      },
      spaceBetween: 0,
      speed: 200,
      slidesPerView: "auto",
      slidesPerGroup: 1,
      grid: {
        rows: 1,
      },
      centerInsufficientSlides: true,
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: this.carouselNext,
        prevEl: this.carouselPrev,
      },
    };

    render(
      <ProductCarousel
        products={products}
        swiperParams={swiperParams}
        cardStyle={cardStyle}
      />,
      this.carousel
    );
  }
}

if (!customElements.get("section-product-carousel")) {
  customElements.define("section-product-carousel", SectionProductCarousel);
}
